import { render } from "./AddWithFeedback.vue?vue&type=template&id=12055dac&scoped=true"
import script from "./AddWithFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./AddWithFeedback.vue?vue&type=script&setup=true&lang=js"

import "./AddWithFeedback.vue?vue&type=style&index=0&id=12055dac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12055dac"],['__file',"src/components/Molecules/AddWithFeedback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12055dac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12055dac', __exports__)) {
    api.reload('12055dac', __exports__)
  }
  
  module.hot.accept("./AddWithFeedback.vue?vue&type=template&id=12055dac&scoped=true", () => {
    api.rerender('12055dac', render)
  })

}


export default __exports__